export default "__VITE_ASSET__c0cbe2f6__"